// Banner Height Updater - Actualiza la altura de los banners según el número de columnas
(function() {
  'use strict';
  
  let isInitialized = false;
  let lastDetectedColumns = 0;
  
  function detectCurrentColumns() {
    // Método 1: Detectar por el ancho de las tarjetas de producto
    const productCards = document.querySelectorAll('.hdt-card-product:not(.hdt-card-product-banner)');
    if (productCards.length > 0) {
      const firstCard = productCards[0];
      const cardWidth = firstCard.offsetWidth;
      const containerWidth = firstCard.closest('.hdt-row-grid')?.offsetWidth || 1200;
      const calculatedColumns = Math.round(containerWidth / cardWidth);
      
      if (calculatedColumns >= 2 && calculatedColumns <= 6) {
        return calculatedColumns;
      }
    }
    
    // Método 2: Detectar por clases CSS en la grilla
    const gridContainer = document.querySelector('.hdt-row-grid');
    if (gridContainer) {
      const classes = gridContainer.className;      
      if (classes.includes('hdt-grid-cols-2')) return 2;
      if (classes.includes('hdt-grid-cols-3')) return 3;
      if (classes.includes('hdt-grid-cols-4')) return 4;
      if (classes.includes('hdt-grid-cols-5')) return 5;
      if (classes.includes('hdt-grid-cols-6')) return 6;
    }
    
    // Método 3: Detectar por botón activo (fallback)
    const activeButton = document.querySelector('.hdt-view-layout-switch button.is-active');
    if (activeButton) {
      const buttonValue = activeButton.getAttribute('value');
      const buttonClass = activeButton.className;
      
      if (buttonValue === '2') return 2;
      if (buttonValue === '3') return 3;
      if (buttonValue === '4') return 4;
      if (buttonValue === '5') return 5;
      if (buttonValue === '6') return 6;
    }
    
    return 4; // Default
  }
  
  function getBannerSpan(banner) {
    // Detectar cuántas columnas ocupa el banner
    // Método 1: Por el atributo grid-column
    const gridColumn = window.getComputedStyle(banner).gridColumn;
    if (gridColumn && gridColumn.includes('span')) {
      const spanMatch = gridColumn.match(/span\s+(\d+)/);
      if (spanMatch) {
        return parseInt(spanMatch[1], 10);
      }
    }
    
    // Método 2: Por la clase banner-span-X
    const classes = banner.className;
    const spanMatch = classes.match(/banner-span-(\d+)/);
    if (spanMatch) {
      return parseInt(spanMatch[1], 10);
    }
    
    // Método 3: Comparar ancho con cards normales
    const productCards = document.querySelectorAll('.hdt-card-product:not(.hdt-card-product-banner)');
    if (productCards.length > 0) {
      const firstCard = productCards[0];
      const cardWidth = firstCard.offsetWidth;
      const bannerWidth = banner.offsetWidth;
      const calculatedSpan = Math.round(bannerWidth / cardWidth);
      if (calculatedSpan >= 1 && calculatedSpan <= 6) {
        return calculatedSpan;
      }
    }
    
    return 1; // Default: 1 columna
  }
  
  function updateBannerHeights() {
    
    // Obtener la altura de una card de producto normal
    const productCards = document.querySelectorAll('.hdt-card-product:not(.hdt-card-product-banner)');
    
    if (productCards.length === 0) {
      return;
    }
    
    // Calcular la altura promedio de las cards de producto
    let totalHeight = 0;
    let cardCount = 0;
    
    productCards.forEach((card) => {
      const cardHeight = card.offsetHeight;
      if (cardHeight > 0) {
        totalHeight += cardHeight;
        cardCount++;
      }
    });
    
    if (cardCount === 0) {
      return;
    }
    
    const averageCardHeight = totalHeight / cardCount;
    
    // Obtener todos los banners
    const banners = document.querySelectorAll('.hdt-card-product-banner');
    
    banners.forEach((banner, index) => {
      // Detectar cuántas columnas ocupa este banner
      const bannerSpan = getBannerSpan(banner);
      
      // Para banners de múltiples columnas, mantener la misma altura que una card
      // pero asegurar que la imagen se ajuste correctamente
      const bannerHeight = averageCardHeight;
      
      // Aplicar altura al banner
      banner.style.height = bannerHeight + 'px';
      banner.style.minHeight = bannerHeight + 'px';
      
      // Aplicar altura al contenedor de imagen para que se ajuste correctamente
      const bannerImageContainer = banner.querySelector('.custom-card-img-url');
      if (bannerImageContainer) {
        // La imagen debe ocupar toda la altura del banner
        bannerImageContainer.style.height = bannerHeight + 'px';
        bannerImageContainer.style.minHeight = bannerHeight + 'px';
        bannerImageContainer.style.maxHeight = bannerHeight + 'px';
        
        // Asegurar que la imagen dentro se ajuste correctamente
        const bannerImage = bannerImageContainer.querySelector('img');
        if (bannerImage) {
          bannerImage.style.height = '100%';
          bannerImage.style.width = '100%';
          bannerImage.style.objectFit = 'cover';
        }
      }
      
    });
  }
  
  function setupEventListeners() {
    // Escuchar clics en botones de cambio de vista
    document.addEventListener('click', function(e) {
      if (e.target.closest('.hdt-view-layout-switch button') || 
          e.target.closest('hdt-view-layout-switch button')) {
        // Dar tiempo para que se actualice la grilla
        setTimeout(updateBannerHeights, 500);
      }
    });
    
    // Escuchar cambios de tamaño de ventana
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(updateBannerHeights, 300);
    });
    
    // Observar cambios en la grilla
    const observer = new MutationObserver(function(mutations) {
      let shouldUpdate = false;
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const target = mutation.target;
          if (target.classList.contains('hdt-row-grid') || 
              target.classList.contains('hdt-card-product')) {
            shouldUpdate = true;
          }
        }
        if (mutation.type === 'childList') {
          const addedNodes = Array.from(mutation.addedNodes);
          const hasProductCards = addedNodes.some(node => 
            node.nodeType === 1 && 
            (node.classList?.contains('hdt-card-product') || 
             node.querySelector?.('.hdt-card-product'))
          );
          if (hasProductCards) {
            shouldUpdate = true;
          }
        }
      });
      if (shouldUpdate) {
        setTimeout(updateBannerHeights, 200);
      }
    });
    
    // Observar la grilla cuando esté disponible
    const checkGrid = setInterval(function() {
      const gridContainer = document.querySelector('.hdt-row-grid');
      if (gridContainer) {
        observer.observe(gridContainer, { 
          attributes: true, 
          childList: true, 
          subtree: true,
          attributeFilter: ['class'] 
        });
        clearInterval(checkGrid);
      }
    }, 100);
  }
  
  function init() {
    if (isInitialized) return;
    isInitialized = true;
    
    updateBannerHeights();
    setupEventListeners();
  }
  
  // Inicializar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Hacer la función disponible globalmente para debugging
  window.updateBannerHeights = updateBannerHeights;
})();
